import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './components/App';

const jsx = (
    <div>
        <App />
    </div>
)

ReactDOM.render(jsx, document.getElementById('app'));
